import { render, staticRenderFns } from "./SubCategoryShow.vue?vue&type=template&id=01ffef87&"
import script from "./SubCategoryShow.vue?vue&type=script&lang=js&"
export * from "./SubCategoryShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports